<template>
  <Popover
    ref="coachmark"
    tag="div"
    class="animate-float animate-iterations-3 align-left relative"
    :visible="true"
    :placement="position"
    :popover-class="`${popoverClasses} shadow-md w-72 animate-float animate-iterations-3`"
    :target="target"
    :arrow-size="16"
    :portal-name="portalName"
    popover-role="dialog"
    :popover-label="ariaLabel"
  >
    <template #popover>
      <slot></slot>
      <div class="flex flex-row items-center justify-end space-x-4">
        <a v-if="learnMoreUrl" :href="learnMoreUrl" target="_blank" size="small" class="text-primary text-sm">
          {{ t('coachmark.learn_more') }}
        </a>
        <LzButton size="small" tabindex="0" @click="$emit('close')">{{ t('coachmark.close') }}</LzButton>
      </div>
    </template>
  </Popover>
</template>

<script setup>
import { ref, computed } from 'vue'
import LzButton from './LzButton'
import { components } from 'vue_features/shared/i18n'
import { pickLocaleNamespace } from 'vue_features/shared/helpers/i18n_helper'
import Popover, { POSITIONS, DEFAULT_PORTAL } from './Popover'
import { useI18n } from 'vue-i18n'

const props = defineProps({
  target: {
    default: null,
    validator: (val) =>
      val === null ||
      typeof val === 'string' ||
      val instanceof HTMLElement ||
      (val && val.constructor.name === 'VueComponent'),
  },
  position: {
    type: String,
    default: 'bottom',
    validator: (val) => POSITIONS.includes(val),
  },
  portalName: {
    type: String,
    default: DEFAULT_PORTAL,
  },
  popoverClasses: {
    type: String,
    default: '',
  },
  learnMoreUrl: {
    type: String,
    default: null,
  },
  label: {
    type: String,
    default: null,
  },
})

const coachmark = ref(null)
const { t } = useI18n({ messages: pickLocaleNamespace(components, 'coachmark') })
const ariaLabel = computed(() => props.label ?? t('coachmark.tip'))
</script>
